import React from 'react';
import { useSelector } from 'react-redux';

import { LegacyPrimaryButton as PrimaryButton } from '@videoblocks/storywind';

import { ContentClass } from '../../../../app/Shared/enums';
import SiteConstants from '../../../../common/SiteConstants/SiteConstants';
import FavoriteButton from '../../../../common/components/FavoriteButton';
import {
  selectDetailsSignUpLink,
  selectDetailsStockItem,
  selectDetailsStockItemFormats,
} from '../../../selectors/detailsSelectors';
import MakerEditorHook from '../../MakerEditorHook';
import SubscriptionValuePropsBox from './SubscriptionValuePropsBox';

import './visitor-sign-up.less';

interface Props {
  makerEditorLink: string;
  signUpButtonCta: string;
  contentClass: ContentClass;
  showMakerHook?: boolean;
  showLicenseLinks?: boolean;
  showFavoriteButton?: boolean;
  showValueProps?: boolean;
}

const VisitorSignUpButton: React.FC<Props> = ({
  makerEditorLink,
  signUpButtonCta,
  contentClass,
  children,
  showMakerHook = true,
  showLicenseLinks = true,
  showFavoriteButton = true,
  showValueProps = false,
}) => {
  const stockItem = useSelector(selectDetailsStockItem);
  const stockItemFormats = useSelector(selectDetailsStockItemFormats);
  const signUpLink = useSelector(selectDetailsSignUpLink);

  return (
    <div className="visitorSignUpButton">
      <>
        {showValueProps ? (
          <SubscriptionValuePropsBox cta={signUpButtonCta} />
        ) : (
          <div
            className="visitorSignUpButton-cta"
            data-cy="visitorSignUpButton-cta"
          >
            <PrimaryButton
              className="hover:no-underline rounded-lg"
              label={signUpButtonCta}
              href={signUpLink}
            />
          </div>
        )}
        <div className="visitorSignUpButton-detailActions">
          {children}
          {showFavoriteButton && (
            <FavoriteButton
              buttonClasses="relative p-1 mx-2 my-0 text-xs bg-gray-100 border-none rounded uppercase"
              buttonText="Add to Folder"
              stockItem={stockItem}
              stockItemFormats={stockItemFormats}
              telemetryKey="details"
              iconClassName="w-4 h-4"
              alternateIconDefaultColor="text-black"
              alternateIconInFolderColor="text-black"
            />
          )}
        </div>
      </>

      {showMakerHook && contentClass !== ContentClass.Audio && (
        <MakerEditorHook makerEditorLink={makerEditorLink} />
      )}

      {showLicenseLinks && (
        <div className="text-sm text-center mt-4">
          Learn more about our{' '}
          <a
            href={SiteConstants.getLicenseComparisonRoute()}
            target="_blank"
            rel="noopener"
            className="text-blue-1000 hover:text-blue-500"
          >
            Licenses
          </a>
        </div>
      )}
    </div>
  );
};

export default VisitorSignUpButton;
